import { render, staticRenderFns } from "./LogAdminDetail.vue?vue&type=template&id=1c53087d&scoped=true"
import script from "./LogAdminDetail.vue?vue&type=script&lang=js"
export * from "./LogAdminDetail.vue?vue&type=script&lang=js"
import style0 from "./LogAdminDetail.vue?vue&type=style&index=0&id=1c53087d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53087d",
  null
  
)

export default component.exports